import { publicAPI } from '../services/api';

export function trackJourney(event_type, table_id, metadata = {}) {
  try {
    let visit = sessionStorage.getItem('glassorder-visit');
    if (!visit) {
      visit = crypto.randomUUID();
      sessionStorage.setItem('glassorder-visit', visit);
    }
    publicAPI.trackEvent({ event_type, table_id, metadata: { ...metadata, visit_id: visit } }).catch(() => {});
  } catch { /* Analytics must never block ordering. */ }
}
